import React from 'react';
import styled from 'styled-components';
import AlertIcon from '../../../../../../../../assets/icons/alert-circle.svg';

export const InfoCard = styled.div`
  display: flex;
  align-items: start;
  text-align: justify;
  margin-top: 24px;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 8px;
`;
const QuotaRecalculeInfo = () => (
  <InfoCard>
    <img src={AlertIcon} alt="Img-alert" />
    <p
      style={{
        paddingLeft: 6,
        fontSize: 13
      }}
    >
      <p
        style={{
          fontWeight: 900
        }}
      >
        ¿Qué son los “recálculos de cuotas”?
      </p>
      Dependiendo de la fecha en la que solicites el Retiro de Curso se pueden
      modificar o no las cuotas no vencidas.
    </p>
  </InfoCard>
);

export { QuotaRecalculeInfo };
